export const SEGMENT = {
  SMALL_BUSINESS: 'SMALL_BUSINESS',
  MEDIUM_BUSINESS: 'MEDIUM_BUSINESS',
  LARGE_BUSINESS: 'LARGE_BUSINESS',
};
